/** @copy-from https://gitlab.poski.com/poskireal/poskireal.cz/blob/0cdf1adb3453ac64f066ba682372cadce5240850/frontend/CID/poski/v25.9/klasik/js/mortgage-calculator.js */
class MortgageCalculator {
    constructor(form) {
        this.form = form && form.closest('form');
        this.resultHolder = this.form && this.form.querySelector('[data-result-holder]');
        this.valueHolder = null;
        this.realEstatePriceHolder = null;
        this.activeStep = 1;
        this.nextStepBtn = null;

        this.mortgage = 10000000;
        this.years = 30;
        this.interestRate = this.form.querySelector('[data-interest-rate]') ? parseFloat(this.form.querySelector('[data-interest-rate]').getAttribute('data-interest-rate')) : 1.59;
        this.calculatorFields = null;

        this.ltvPercent = parseInt(this.form.querySelector('[data-mortgage-ltv]').getAttribute('data-mortgage-ltv'), 10);
        this.ltvMaxAmountElement = this.form.querySelector('[data-mortgage-ltv-amount-max]');
        this._init();
    }

    _parseNumericValue(value) {
        const parsedValue = parseInt(String(value).replace(/\s/g, ""), 10);
        return !isNaN(parsedValue) ? parsedValue : 0;
    }

    _getMortgageLimitFromEstatePrice(realEstatePrice) {
        return this._parseNumericValue(
            (this._parseNumericValue(realEstatePrice) * (this.ltvPercent / 100)).toFixed()
        );
    }

    _formatSimpleInput(input) {
        const value = this._parseNumericValue(input.value);
        input.value = value.toLocaleString("cs-CZ", {
            style: "decimal",
            maximumFractionDigits: 2
        });
    }

    _toggleStep(target) {
        const steps = Array.from(this.form.querySelectorAll('[data-step]')),
            targetStep = steps.find(e => parseInt(e.dataset.step) === parseInt(target));

        if(!targetStep)
            return;

        steps.forEach(step => step.classList.remove('is-active'));
        targetStep.classList.add('is-active');
        this.activeStep = target;
    }

    _initComponents() {
        this.form.querySelectorAll('[data-calculator-range]').forEach(slider => {
            const sliderInput = slider.closest('.MortgageCalc-row').querySelector('input[name="'+ slider.dataset.id +'"]');
            const min = parseInt(slider.dataset.min ?? 1, 10);
            const max = parseInt(slider.dataset.max ?? 40, 10);
            const startCandidate = this._parseNumericValue(sliderInput.value || slider.dataset.start || min);
            const start = Math.min(max, Math.max(min, startCandidate));

            noUiSlider.create(slider, {
                behaviour: 'snap',
                start: start,
                connect: 'lower',
                range: {
                    'min': min,
                    'max': max
                },
                ariaFormat: wNumb({
                    decimals: 0
                }),
                format: wNumb({
                    decimals: 0,
                    thousand: " "
                })
            });

            slider.noUiSlider.on('update', (values, handle) => {
                sliderInput.value = values[handle];
            });

            slider.noUiSlider.on('change', () => sliderInput.dispatchEvent(new Event('change')));
            sliderInput.addEventListener('change', () => slider.noUiSlider.set(sliderInput.value));
            sliderInput.slider = slider.noUiSlider;
        });
    }

    _applyInterestRate(rate) {
        this.form.querySelectorAll('[data-interest-rate]').forEach(el => { el.textContent = rate });
        console.log('nastavuji rate: ', rate);
        this._reCalculate();
    }

    _readCalculatorData() {
        this.calculatorFields = Array.from(this.form.querySelectorAll('[data-calculator-field]'));
        this.calculatorFields.forEach(field => this._processFieldChange(field, false));
        this.valueHolder = this.calculatorFields.find(e => e.dataset.calculatorField === 'mortgage');
        this.realEstatePriceHolder = this.form.querySelector('[data-real-estate-price-input]');
        this.nextStepBtn = this.form.querySelector('button[data-next-step]');
    }

    _processFieldChange(field, recalculate = true) {
        const fieldName = field.dataset.calculatorField;
        if(!fieldName) return;

        this[fieldName] = this._parseNumericValue(field.value);
        recalculate && this._reCalculate();
    }

    _reCalculate() {
        if (!this.mortgage || !this.years || !this.interestRate) {
            this._setResult(0);
            return;
        }
        const totalMonths = parseInt(this.years, 10) * 12;
        const q = parseFloat(this.interestRate) / 100 / 12;
        const qn = (1 + q) ** totalMonths;
        console.log('this.interestRate', this.interestRate);
        console.log('parseFloat(this.interestRate) / 100', parseFloat(this.interestRate) / 100);
        console.log('totalMonths', totalMonths);
        console.log('q', q);
        console.log('qn', qn);
        console.log('result', Math.round((parseInt(this.mortgage, 10) * q * qn) / (qn - 1) || 0));
        this._setResult(Math.round((parseInt(this.mortgage, 10) * q * qn) / (qn - 1) || 0));
    }

    _setResult(result) {
        const valid = result > 0;
        this.resultHolder.textContent = valid ? formatCena(result) + ' Kč' : 'hypotéka nelze sjednat';
        this.nextStepBtn.disabled = !valid;
    }

    _setMortgageLimit(limit) {
        const min = this.valueHolder.slider.options.range.min;
        const normalizedLimit = Math.max(this._parseNumericValue(limit), min);
        const isMinimum = normalizedLimit === min;
        const max = isMinimum ? min + 1 : normalizedLimit;

        if(isMinimum) {
            this.valueHolder.slider.target.setAttribute('disabled', isMinimum);
            this.valueHolder.slider.set(min);
        } else {
            this.valueHolder.slider.target.removeAttribute('disabled');
        }

        this.valueHolder.slider.updateOptions({range: {'min': min, 'max' : max}}, true);
        this.ltvMaxAmountElement.textContent = formatCena(normalizedLimit); // nastaveni prave=max hodnoty slideru dle LTV limitu
        this.valueHolder.disabled = isMinimum;
        this._processFieldChange(this.valueHolder);
    }

    _addEventListeners() {
        this.form.querySelectorAll('button[data-next-step]').forEach((el) => el.addEventListener('click', (e) => this._toggleStep(e.target.dataset.nextStep)));
        this.calculatorFields.forEach(field => field.addEventListener('change', () => this._processFieldChange(field)));
        this.realEstatePriceHolder && this.realEstatePriceHolder.addEventListener("change", () => this._setMortgageLimit(this._getMortgageLimitFromEstatePrice(this.realEstatePriceHolder.value)));
        this.form.addEventListener('submit', () => this._processBeforeSubmit());
    }

    _processBeforeSubmit() {
        this.realEstatePriceHolder.value = formatCena(this.realEstatePriceHolder.value);
        this.form.querySelector('input#monthly-payment').value = this.resultHolder.textContent;
        return true;
    }

    _init() {
        if(!this.form)
            return;

        this._readCalculatorData();
        this._initComponents();
        this._addEventListeners();
        this.realEstatePriceHolder && this._setMortgageLimit(this._getMortgageLimitFromEstatePrice(this.realEstatePriceHolder.value));
        this._reCalculate();

        if(window.location.hash && (this.form.querySelectorAll('.errors').length || this.form.querySelectorAll('#captchaimage').length))
            this._toggleStep(2);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new MortgageCalculator(document.querySelector('[data-mortgage-calculator]'));
    document.querySelectorAll('button[data-refresh-calculator]').forEach(btn => btn.addEventListener('click', () => {
        window.location = window.location.href.split("#")[0];
    }));
});
